import { render } from "./MainSettingsPage.vue?vue&type=template&id=bec44ea6"
import script from "./MainSettingsPage.vue?vue&type=script&lang=js"
export * from "./MainSettingsPage.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__